import React, { useEffect } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';

import compose from 'helpers/compose';

import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import Typography from '@material-ui/core/Typography/Typography';

import PortfolioTableComparison from 'components/PortfolioTables/PortfolioTableComparison';

import { WorkflowPlanStore } from 'stores/workflowStores/newWorkflowPlanStore/workflowPlanStore';
import Info from 'components/Tooltip/Info';
import { translatePortfolioCode } from 'helpers/helpers';
import Button from '@material-ui/core/Button/Button';

interface Props {
  handleClose: () => void;
  store: WorkflowPlanStore;
}

const BucketUpdate: React.FC<Props> = ({ store, handleClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      await store.getRecommendedBucket();
    })();
  }, [store]);

  return (
    <Dialog maxWidth="md" open={true}>
      <DialogHeader onClose={handleClose}>{t('')}</DialogHeader>
      <DialogContent>
        {store.portfolioComparison.length && (
          <>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography variant="h2">
                  {t('bucket.recommendedComposition')}{' '}
                  {t(`${store.activatedBucket!.title}${store.data?.portfolioOnly ? '_portfolioOnly' : ''}.detail`)}
                </Typography>
              </Grid>
              <Grid item xs={12} alignItems="center">
                {t('bucket_selectedInvestmentStrategy_detail')}
              </Grid>
              <Grid item xs={6}>
                {t('bucket_selectedInvestmentStrategy')}
                <Info content={t('bucket_selectedInvestmentStrategy_tooltip')} iconProps={{ fontSize: 'small' }} />
              </Grid>
              <Grid item xs={6} style={{ fontWeight: 'bold' }}>
                {translatePortfolioCode(store.activatedBucket!.portfolio.code)}
              </Grid>
            </Grid>
            <PortfolioTableComparison
              bucketType={store.activatedBucket!.type}
              comparison={store.portfolioComparison[0]}
              showRebalancing={false}
              showInstruments={true}
              portfolioUpdate
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="default">
          {t('general_back')}
        </Button>
        <Button
          onClick={async () => {
            const ok = await store.updateBucket();
            if (ok) handleClose();
          }}
          variant="contained"
          color="primary"
        >
          {t('general_update')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default compose(observer)(BucketUpdate);
